// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"abdb7aa2e5a51ed31e81","691":"3c076bd60e8757ab3473"}[chunkId] + ".js";
};